(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-eurofase-dealer-guide"] && !Shopify.designMode) return;
  try {
    
(function(){
  function setup(root){
    if(root.dataset.efgInit==='1')return;
    var l=root.querySelector('#efg-l'),w=root.querySelector('#efg-w'),m=root.querySelector('#efg-m'),q=root.querySelector('#efg-q'),out=root.querySelector('#efg-out');
    if(!l||!w||!m||!q||!out)return;
    root.dataset.efgInit='1';
    function run(){
      var length=Number(l.value),width=Number(w.value),area=length*width;
      if(!Number.isFinite(length)||!Number.isFinite(width)||length<=0||width<=0||length>200||width>200){out.textContent='Enter positive dimensions of 200 ft or less for each side.';return;}
      if(area>5000){out.textContent='Large project area: send your plans for a manufacturer-reviewed multi-zone layout. No heater count is estimated.';return;}
      var opt=m.options[m.selectedIndex],n=q.value.trim()===''?null:Number(q.value);
      if(n!==null&&(!Number.isInteger(n)||n<1||n>24)){out.textContent='Enter 1–24 proposed units, or leave the quantity field blank.';return;}
      var ratio=area/Number(opt.value),extra='';
      if(n!==null){extra=' Your proposed '+n+' unit'+(n===1?'':'s')+' represent '+(n*Number(opt.dataset.w)/1000).toFixed(1)+' kW nominal heater nameplate power; not circuit sizing or a comfort guarantee.';}
      out.textContent='Zone: '+area.toLocaleString('en-CA',{maximumFractionDigits:1})+' sq ft. '+opt.dataset.name+' published approximate single-unit footprint: '+opt.dataset.dims+'. The zone is '+ratio.toFixed(1)+' times this footprint by area — NOT an equipment count or layout. Mounting, wind, aiming and overlap matter.'+extra;
    }
    [l,w,m,q].forEach(function(el){el.addEventListener('input',run);el.addEventListener('change',run);});run();
  }
  function init(){document.querySelectorAll('[data-efg-guide]').forEach(setup);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
